module.exports = __webpack_public_path__ + "img/front_11.c74bf062.svg";